import { render, staticRenderFns } from "./MonthlyReview.vue?vue&type=template&id=1ca29919"
import script from "./MonthlyReview.vue?vue&type=script&lang=js"
export * from "./MonthlyReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports